/*
 * The MIT License
 *
 * Copyright (c) 2013, Sebastian Sdorra
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
'use strict';

angular.module('mainDashboard', [
	'adf', 'angular-loading-bar', 'angularutilities', 'widgets.buyer', 'widgets.supplychain', 'LocalStorageModule',
	'structures', 'userdashboard',
	'multi-select', 'pascalprecht.translate', 'widgets.initiative', 'widgets.controltower'
])
	.value('hostUrl', '/api/')
	.value('dashboardListUrl', '2/factndx/')
	.value('addUserDashboardUrl', '2/factndx/')
	.value('businessAnalytics', 'Spend Summary Dashboard')
	.value('performanceDashboardDescription', 'Performance metrics')
	.value('reportDashboards', ['buyer-performance', 'site-performance', 'planner-performance-single-level', 'planner-performance-multi-level', 'item-group-performance'])
	// Lodash Compatibility
	.constant('_', window._)
	.run(function($rootScope) {
		$rootScope._ = window._;
	})
	.directive('focusOn', function() {
		return function(scope, elem, attr) {
			scope.$on('focusOn', function(e, name) {
				if (name === attr.focusOn) {
					jQuery('[autofocus]:not(:focus)').eq(0).focus();
				}
			});
		};
	}).factory('focus', function($rootScope, $timeout) {
		return function(name) {
			$timeout(function() {
				$rootScope.$broadcast('focusOn', name);
			});
		};
	});
